import { useFormik } from "formik";
import RadioInput from "../../common/RedioComponent/RadioInput";
import Header from "../../component/Header";
import Layout from "../../component/Layout";
import UsePagination from "../../component/pagination";
import * as S from "./MedicalRecords.Styles";
import * as yup from "yup";
const MedicalRecords = ({ step, setStep }) => {
  const checkOption = [
    { label: " کمتر از ۱۲۰ میلیمتر  جیوه (کمتر از ۱۲) ", value: "119" },
    { label: "  بین ۱۲۰ تا ۱۳۹  میلیمتر جیوه (بین ۱۲ تا ۱۴)", value: "139" },
    { label: "  بین ۱۴۰ تا ۱۵۹ میلیمتر جیوه (بین ۱۴ تا ۱۶)", value: "159" },
    { label: " بین ۱۶۰ تا ۱۷۹ میلیمتر جیوه (بین ۱۶ تا ۱۸)", value: "179" },
    {
      label: "مساوی یا بیشتر از ۱۸۰ میلیمتر جیوه (بیشتر از ۱۸) ",
      value: "180",
    },
  ];
  const initialValues = {
    bps: JSON.parse(localStorage.getItem("infoPerson"))[step - 1]
      ? JSON.parse(localStorage.getItem("infoPerson"))[step - 1].bps
      : "",
  };

  //2.
  const onSubmit = (values) => {
    const datas = JSON.parse(localStorage.getItem("infoPerson"));
    let info = localStorage.getItem("infoPerson");
    if (info) {
      let parseInfo = JSON.parse(info);
      parseInfo[3] = values;
      localStorage.setItem("infoPerson", JSON.stringify(parseInfo));
    } else {
      datas.push(values);
      localStorage.setItem("infoPerson", JSON.stringify(datas));
    }

    localStorage.setItem("step", JSON.stringify(step));
    setStep(
      parseInt(localStorage.getItem("step"))
        ? parseInt(localStorage.getItem("step")) + 1
        : 4
    );
  };

  //3.
  const validationSchema = yup.object({
    bps: yup.string().required("یک مورد را بزنید"),
  });

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
    enableReinitialize: true,
  });

  return (
    <>
      <Header>
        <S.BgHeader style={{ backgroundImage: `url("images/Header2.png")` }}>
          <S.ContentHeader>
            <S.TitleHeader>سوابق پزشکی</S.TitleHeader>
            <img src="/images/medication.png" width={128} alt="header" />
          </S.ContentHeader>
        </S.BgHeader>
      </Header>
      <Layout>
        <S.Container>
          <S.RadioWrraper>
            <form onSubmit={formik.handleSubmit}>
              <S.Title>فشار خون شما حدودا در چه محدوده‌ای قرار دارد:</S.Title>
              <RadioInput
                formik={formik}
                name={"bps"}
                radioOption={checkOption}
              />

              <UsePagination step={step} setStep={setStep} formik={formik} />
            </form>
          </S.RadioWrraper>
        </S.Container>
      </Layout>
    </>
  );
};

export default MedicalRecords;
